import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { CutoffTimer } from "../CutoffDate/CutoffTimer";
import IconBreadcrumbs from "./Breadcrumbs";
import { HeaderContentOptions } from "../../sharedTypes/ConfigurationTypes";
import { useRouteMatch } from "../../hooks/useRouteMatch";
import { LoggedOutNav } from "../Navigation/LoggedOutNav";
/**
 *
 * @param GeneralSettings
 * @returns
 */
export const useTopBar = (settings) => {
    const { isLocationPage, isGiftCardFlow } = useRouteMatch();
    const usesTopBar = settings.UseTopBar;
    // Check UseTopBar first and return immediately if false
    if (!usesTopBar) {
        return {
            componentToRender: _jsx(LoggedOutNav, {}),
            usesTopBar,
        };
    }
    const headerContent = isGiftCardFlow ? settings.HeaderContentGiftCard : settings.HeaderContentOrderFlow;
    // Return directly from switch.
    switch (headerContent) {
        case HeaderContentOptions.Navigation:
            return {
                componentToRender: _jsx(LoggedOutNav, {}),
                usesTopBar,
            };
        case HeaderContentOptions.Breadcrumbs:
            return {
                componentToRender: _jsx(IconBreadcrumbs, {}),
                usesTopBar,
            };
        case HeaderContentOptions.Countdown:
            return {
                componentToRender: !isLocationPage ? _jsx(CutoffTimer, { format: "d:h:m:s" }) : _jsx(_Fragment, {}),
                usesTopBar,
            };
        case HeaderContentOptions.None:
            return {
                componentToRender: null,
                usesTopBar,
            };
        default:
            return {
                componentToRender: null,
                usesTopBar,
            };
    }
};
